<!--
  Vue wrapper for Bryntum ResourceUtilization
-->

<template>
    <div>
        <!-- Container for Vue components used in cells, hidden from view -->
        <div
            ref   = "cellInstancesHolder"
            style = "display: none"
        >
            <component
                :is    = "component.is"
                v-for  = "component in cellInstances"
                :ref   = "component.key"
                :key   = "component.key"
                v-bind = "component"
            />
        </div>
    </div>
</template>

<script>

import { AjaxStore, AssignmentModel, Base, Column, ColumnStore, Container, CrudManager, Editor, Field, Grid, GridBase, GridLocation, Histogram, Mask, Menu, MenuItem, Model, Panel, PresetStore, ProjectModel, RecurrenceConfirmationPopup, ResourceNonWorkingTime, ResourceTimeRangeModel, ResourceTimeRangeStore, ResourceTimeRanges, ResourceUtilization, ResourceUtilizationModel, Row, Scheduler, SchedulerAssignmentModel, SchedulerEventModel, SchedulerPro, SchedulerResourceModel, ScrollManager, Scroller, StateProvider, Store, SubGrid, TimeAxis, TimeAxisColumn, TimeSpan, TimelineBase, TimelineHistogram, Tool, VerticalTimeAxisColumn, ViewPreset, Widget } from '@bryntum/schedulerpro';

import { StringHelper } from '@bryntum/schedulerpro';
import WrapperHelper from './WrapperHelper.js';

export default {

    // eslint-disable-next-line vue/multi-word-component-names
    name : 'BryntumResourceUtilization',

    props : {

        // Configs only
        adopt                            : { type : [HTMLElement, String], default : undefined },
        aggregateDataEntry               : { type : Function, default : undefined },
        aggregateHistogramDataForGroups  : { type : Boolean, default : undefined },
        animateFilterRemovals            : { type : Boolean, default : undefined },
        animateRemovingRows              : { type : Boolean, default : undefined },
        animateTreeNodeToggle            : { type : Boolean, default : undefined },
        ariaDescription                  : { type : String, default : undefined },
        ariaLabel                        : { type : String, default : undefined },
        assignmentFilterFn               : { type : Function, default : undefined },
        autoAdjustTimeAxis               : { type : Boolean, default : undefined },
        autoHeight                       : { type : Boolean, default : undefined },
        barTextEffortUnit                : { type : String, default : undefined },
        barTipEffortUnit                 : { type : String, default : undefined },
        barTooltipTemplate               : { type : Function, default : undefined },
        bbar                             : { type : [Array, Object, null], default : undefined },
        bodyCls                          : { type : [String, Object], default : undefined },
        bubbleEvents                     : { type : Object, default : undefined },
        bufferCoef                       : { type : Number, default : undefined },
        bufferThreshold                  : { type : Number, default : undefined },
        callOnFunctions                  : { type : Boolean, default : undefined },
        collapsible                      : { type : [Boolean, Object], default : undefined },
        config                           : { type : Object, default : undefined },
        contentElementCls                : { type : [String, Object], default : undefined },
        contextMenuTriggerEvent          : { type : String, default : undefined },
        dataModelField                   : { type : String, default : undefined },
        defaultRegion                    : { type : String, default : undefined },
        defaultResourceImageName         : { type : String, default : undefined },
        destroyStore                     : { type : Boolean, default : undefined },
        destroyStores                    : { type : Boolean, default : undefined },
        disableGridColumnIdWarning       : { type : Boolean, default : undefined },
        disableGridRowModelWarning       : { type : Boolean, default : undefined },
        dock                             : { type : [String, Object], default : undefined },
        drawer                           : { type : [Boolean, String], default : undefined },
        effortFormat                     : { type : String, default : undefined },
        effortUnit                       : { type : String, default : undefined },
        elementAttributes                : { type : Object, default : undefined },
        enableSticky                     : { type : Boolean, default : undefined },
        enableTextSelection              : { type : Boolean, default : undefined },
        endParamName                     : { type : String, default : undefined },
        fillLastColumn                   : { type : Boolean, default : undefined },
        fixedRowHeight                   : { type : Boolean, default : undefined },
        footer                           : { type : [Object, String], default : undefined },
        formulaProviders                 : { type : Object, default : undefined },
        fullRowRefresh                   : { type : Boolean, default : undefined },
        getBarClass                      : { type : Function, default : undefined },
        getBarDOMConfig                  : { type : Function, default : undefined },
        getBarText                       : { type : Function, default : undefined },
        getBarTextDOMConfig              : { type : Function, default : undefined },
        getDataEntryForAggregating       : { type : Function, default : undefined },
        getOutlineClass                  : { type : Function, default : undefined },
        getOutlineDOMConfig              : { type : Function, default : undefined },
        getRecordData                    : { type : Function, default : undefined },
        getRowHeight                     : { type : Function, default : undefined },
        hardRefreshOnTimeAxisReconfigure : { type : Boolean, default : undefined },
        header                           : { type : [String, Boolean, Object], default : undefined },
        hideHorizontalScrollbar          : { type : Boolean, default : undefined },
        histogramWidgetClass             : { type : Histogram, default : undefined },
        hoverCls                         : { type : String, default : undefined },
        ignoreDomEventsWhileScrolling    : { type : Boolean, default : undefined },
        ignoreParentReadOnly             : { type : Boolean, default : undefined },
        includeInactiveEvents            : { type : Boolean, default : undefined },
        initAggregatedDataEntry          : { type : Function, default : undefined },
        listeners                        : { type : Object, default : undefined },
        loadMask                         : { type : [String, Object, null], default : undefined },
        loadMaskDefaults                 : { type : Object, default : undefined },
        loadMaskError                    : { type : [Object, Mask, Boolean], default : undefined },
        localizable                      : { type : Boolean, default : undefined },
        managedEventSizing               : { type : Boolean, default : undefined },
        maskDefaults                     : { type : Object, default : undefined },
        masked                           : { type : [Boolean, String, Object], default : undefined },
        maxDate                          : { type : [Date, String], default : undefined },
        maxTimeAxisUnit                  : { type : String, default : undefined },
        minDate                          : { type : [Date, String], default : undefined },
        monitorResize                    : { type : Boolean, default : undefined },
        owner                            : { type : Widget, default : undefined },
        partner                          : { type : TimelineBase, default : undefined },
        passStartEndParameters           : { type : Boolean, default : undefined },
        plugins                          : { type : Array, default : undefined },
        preserveFocusOnDatasetChange     : { type : Boolean, default : undefined },
        preserveScrollOnDatasetChange    : { type : Boolean, default : undefined },
        preventTooltipOnTouch            : { type : Boolean, default : undefined },
        relayStoreEvents                 : { type : Boolean, default : undefined },
        resizable                        : { type : [Boolean, Object], default : undefined },
        resizeToFitIncludesHeader        : { type : Boolean, default : undefined },
        resourceImageExtension           : { type : String, default : undefined },
        resourceImagePath                : { type : String, default : undefined },
        resourceTimeRangeRenderer        : { type : Function, default : undefined },
        respectStoreFilters              : { type : Boolean, default : undefined },
        responsiveLevels                 : { type : Object, default : undefined },
        ripple                           : { type : [Boolean, Object], default : undefined },
        rootElement                      : { type : [ShadowRoot, HTMLElement], default : undefined },
        scaleColumn                      : { type : Object, default : undefined },
        scalePoints                      : { type : Array, default : undefined },
        scrollerClass                    : { type : Function, default : undefined },
        scrollManager                    : { type : [Object, ScrollManager], default : undefined },
        series                           : { type : Object, default : undefined },
        showBarText                      : { type : Boolean, default : undefined },
        showDirty                        : { type : [Boolean, Object], default : undefined },
        showEffortUnit                   : { type : Boolean, default : undefined },
        snapRelativeToEventStartDate     : { type : Boolean, default : undefined },
        startParamName                   : { type : String, default : undefined },
        stateful                         : { type : [Boolean, Object, Array], default : undefined },
        statefulEvents                   : { type : [Object, Array], default : undefined },
        stateId                          : { type : String, default : undefined },
        stateProvider                    : { type : StateProvider, default : undefined },
        stickyHeaders                    : { type : Boolean, default : undefined },
        strips                           : { type : Object, default : undefined },
        subGridConfigs                   : { type : Object, default : undefined },
        syncMask                         : { type : [String, Object, null], default : undefined },
        tab                              : { type : [Boolean, Object], default : undefined },
        tabBarItems                      : { type : Array, default : undefined },
        tbar                             : { type : [Array, Object, null], default : undefined },
        timeAxis                         : { type : [Object, TimeAxis], default : undefined },
        type                             : { type : String, default : undefined },
        ui                               : { type : [String, Object], default : undefined },
        visibleZoomFactor                : { type : Number, default : undefined },
        weekStartDay                     : { type : Number, default : undefined },
        weight                           : { type : Number, default : undefined },
        zoomKeepsOriginalTimespan        : { type : Boolean, default : undefined },
        zoomOnMouseWheel                 : { type : Boolean, default : undefined },
        zoomOnTimeAxisDoubleClick        : { type : Boolean, default : undefined },

        // Configs and properties
        alignSelf                   : { type : String, default : undefined },
        appendTo                    : { type : [HTMLElement, String], default : undefined },
        ariaLive                    : { type : String, default : undefined },
        barMargin                   : { type : Number, default : undefined },
        cellEllipsis                : { type : Boolean, default : undefined },
        cls                         : { type : [String, Object], default : undefined },
        collapsed                   : { type : Boolean, default : undefined },
        columnLines                 : { type : Boolean, default : undefined },
        columns                     : { type : [ColumnStore, Array, Object], default : undefined },
        dataset                     : { type : Object, default : undefined },
        disabled                    : { type : [Boolean, String], default : undefined },
        displayDateFormat           : { type : String, default : undefined },
        emptyText                   : { type : [String, Object], default : undefined },
        enableEventAnimations       : { type : Boolean, default : undefined },
        enableUndoRedoKeys          : { type : Boolean, default : undefined },
        endDate                     : { type : [Date, String], default : undefined },
        extraData                   : { type : Object, default : undefined },
        fillTicks                   : { type : Boolean, default : undefined },
        flex                        : { type : [Number, String], default : undefined },
        forceFit                    : { type : Boolean, default : undefined },
        height                      : { type : [Number, String], default : undefined },
        hidden                      : { type : Boolean, default : undefined },
        hideFooters                 : { type : Boolean, default : undefined },
        hideHeaders                 : { type : Boolean, default : undefined },
        hideRowHover                : { type : Boolean, default : undefined },
        histogramWidget             : { type : [Histogram, Object], default : undefined },
        id                          : { type : String, default : undefined },
        infiniteScroll              : { type : Boolean, default : undefined },
        insertBefore                : { type : [HTMLElement, String], default : undefined },
        insertFirst                 : { type : [HTMLElement, String], default : undefined },
        keyMap                      : { type : Object, default : undefined },
        longPressTime               : { type : Number, default : undefined },
        margin                      : { type : [Number, String], default : undefined },
        maxHeight                   : { type : [String, Number], default : undefined },
        maxWidth                    : { type : [String, Number], default : undefined },
        maxZoomLevel                : { type : Number, default : undefined },
        minHeight                   : { type : [String, Number], default : undefined },
        minWidth                    : { type : [String, Number], default : undefined },
        minZoomLevel                : { type : Number, default : undefined },
        preserveScroll              : { type : [Object, Boolean], default : undefined },
        presets                     : { type : [PresetStore, Array], default : undefined },
        project                     : { type : [ProjectModel, Object], default : undefined },
        readOnly                    : { type : Boolean, default : undefined },
        recurrenceConfirmationPopup : { type : [Object, RecurrenceConfirmationPopup], default : undefined },
        resourceMargin              : { type : [Number, Object], default : undefined },
        resourceTimeRanges          : { type : Array, default : undefined },
        resourceTimeRangeStore      : { type : [ResourceTimeRangeStore, Object], default : undefined },
        rowHeight                   : { type : Number, default : undefined },
        rowLines                    : { type : Boolean, default : undefined },
        rtl                         : { type : Boolean, default : undefined },
        scrollable                  : { type : [Scroller, Boolean, Object], default : undefined },
        selectionMode               : { type : Object, default : undefined },
        showBarTip                  : { type : [Boolean, Object], default : undefined },
        snap                        : { type : Boolean, default : undefined },
        startDate                   : { type : [Date, String], default : undefined },
        stateSettings               : { type : Object, default : undefined },
        store                       : { type : [Store, Object, AjaxStore], default : undefined },
        suppressFit                 : { type : Boolean, default : undefined },
        tickSize                    : { type : Number, default : undefined },
        timeRanges                  : { type : Array, default : undefined },
        timeRangeStore              : { type : [Store, Object], default : undefined },
        timeResolution              : { type : [Object, Number], default : undefined },
        title                       : { type : String, default : undefined },
        tools                       : { type : [Object, null], default : undefined },
        transitionDuration          : { type : Number, default : undefined },
        viewPreset                  : { type : [ViewPreset, Object, String], default : undefined },
        visibleDate                 : { type : [Object, Date], default : undefined },
        width                       : { type : [Number, String], default : undefined },
        workingTime                 : { type : Object, default : undefined },

        // Properties only
        crudManager     : { type : CrudManager, default : undefined },
        data            : { type : Array, default : undefined },
        eventColor      : { type : [String, null], default : undefined },
        eventStyle      : { type : [String, null], default : undefined },
        focusVisible    : { type : Boolean, default : undefined },
        hasChanges      : { type : Boolean, default : undefined },
        isEngineReady   : { type : Boolean, default : undefined },
        originalStore   : { type : Store, default : undefined },
        parent          : { type : Widget, default : undefined },
        scrollLeft      : { type : Number, default : undefined },
        scrollTop       : { type : Number, default : undefined },
        scrollX         : { type : Number, default : undefined },
        selectedCell    : { type : [GridLocation, Object], default : undefined },
        selectedCells   : { type : Array, default : undefined },
        selectedRecord  : { type : Model, default : undefined },
        selectedRecords : { type : Array, default : undefined },
        selectedRows    : { type : Array, default : undefined },
        state           : { type : Object, default : undefined },
        timeZone        : { type : [String, Number], default : undefined },
        tooltip         : { type : [String, Object], default : undefined },
        zoomLevel       : { type : Number, default : undefined },

        // Events
        onBeforeAssignmentDelete            : { type : Function },
        onBeforeCancelCellEdit              : { type : Function },
        onBeforeCancelRowEdit               : { type : Function },
        onBeforeCellDelete                  : { type : Function },
        onBeforeCellEditStart               : { type : Function },
        onBeforeColumnDragStart             : { type : Function },
        onBeforeColumnDropFinalize          : { type : Function },
        onBeforeColumnResize                : { type : Function },
        onBeforeCopy                        : { type : Function },
        onBeforeCSVExport                   : { type : Function },
        onBeforeDestroy                     : { type : Function },
        onBeforeEventDelete                 : { type : Function },
        onBeforeExcelExport                 : { type : Function },
        onBeforeFillHandleDragStart         : { type : Function },
        onBeforeFinishCellEdit              : { type : Function },
        onBeforeFinishRowEdit               : { type : Function },
        onBeforeHide                        : { type : Function },
        onBeforeHistogramDataCacheSet       : { type : Function },
        onBeforePan                         : { type : Function },
        onBeforePaste                       : { type : Function },
        onBeforePdfExport                   : { type : Function },
        onBeforePresetChange                : { type : Function },
        onBeforeRenderHistogramRow          : { type : Function },
        onBeforeRenderRecordHistogram       : { type : Function },
        onBeforeRenderRow                   : { type : Function },
        onBeforeRenderRows                  : { type : Function },
        onBeforeRowCollapse                 : { type : Function },
        onBeforeRowExpand                   : { type : Function },
        onBeforeSelectionChange             : { type : Function },
        onBeforeSetRecord                   : { type : Function },
        onBeforeShow                        : { type : Function },
        onBeforeStartRowEdit                : { type : Function },
        onBeforeStateApply                  : { type : Function },
        onBeforeStateSave                   : { type : Function },
        onBeforeToggleGroup                 : { type : Function },
        onBeforeToggleNode                  : { type : Function },
        onCancelCellEdit                    : { type : Function },
        onCatchAll                          : { type : Function },
        onCellClick                         : { type : Function },
        onCellContextMenu                   : { type : Function },
        onCellDblClick                      : { type : Function },
        onCellMenuBeforeShow                : { type : Function },
        onCellMenuItem                      : { type : Function },
        onCellMenuShow                      : { type : Function },
        onCellMenuToggleItem                : { type : Function },
        onCellMouseEnter                    : { type : Function },
        onCellMouseLeave                    : { type : Function },
        onCellMouseOut                      : { type : Function },
        onCellMouseOver                     : { type : Function },
        onCollapse                          : { type : Function },
        onCollapseNode                      : { type : Function },
        onColumnDrag                        : { type : Function },
        onColumnDragStart                   : { type : Function },
        onColumnDrop                        : { type : Function },
        onColumnResize                      : { type : Function },
        onColumnResizeStart                 : { type : Function },
        onContextMenuItem                   : { type : Function },
        onContextMenuToggleItem             : { type : Function },
        onCopy                              : { type : Function },
        onCurrentTimelineUpdate             : { type : Function },
        onDataChange                        : { type : Function },
        onDateRangeChange                   : { type : Function },
        onDestroy                           : { type : Function },
        onDirtyStateChange                  : { type : Function },
        onDragSelecting                     : { type : Function },
        onExpand                            : { type : Function },
        onExpandNode                        : { type : Function },
        onFileDrop                          : { type : Function },
        onFillHandleBeforeDragFinalize      : { type : Function },
        onFillHandleDrag                    : { type : Function },
        onFillHandleDragAbort               : { type : Function },
        onFillHandleDragEnd                 : { type : Function },
        onFillHandleDragStart               : { type : Function },
        onFinishCellEdit                    : { type : Function },
        onFinishRowEdit                     : { type : Function },
        onFocusIn                           : { type : Function },
        onFocusOut                          : { type : Function },
        onGridRowBeforeDragStart            : { type : Function },
        onGridRowBeforeDropFinalize         : { type : Function },
        onGridRowDrag                       : { type : Function },
        onGridRowDragAbort                  : { type : Function },
        onGridRowDragStart                  : { type : Function },
        onGridRowDrop                       : { type : Function },
        onHeaderClick                       : { type : Function },
        onHeaderMenuBeforeShow              : { type : Function },
        onHeaderMenuItem                    : { type : Function },
        onHeaderMenuShow                    : { type : Function },
        onHeaderMenuToggleItem              : { type : Function },
        onHide                              : { type : Function },
        onHistogramDataCacheSet             : { type : Function },
        onLockRows                          : { type : Function },
        onMouseOut                          : { type : Function },
        onMouseOver                         : { type : Function },
        onPaint                             : { type : Function },
        onPaste                             : { type : Function },
        onPdfExport                         : { type : Function },
        onPresetChange                      : { type : Function },
        onReadOnly                          : { type : Function },
        onRecompose                         : { type : Function },
        onRenderRow                         : { type : Function },
        onRenderRows                        : { type : Function },
        onResize                            : { type : Function },
        onResourceMenuBeforeShow            : { type : Function },
        onResourceMenuItem                  : { type : Function },
        onResourceMenuShow                  : { type : Function },
        onResourceMenuToggleItem            : { type : Function },
        onResourceNonWorkingTimeClick       : { type : Function },
        onResourceNonWorkingTimeContextMenu : { type : Function },
        onResourceNonWorkingTimeDblClick    : { type : Function },
        onResourceNonWorkingTimeMouseDown   : { type : Function },
        onResourceNonWorkingTimeMouseOut    : { type : Function },
        onResourceNonWorkingTimeMouseOver   : { type : Function },
        onResourceNonWorkingTimeMouseUp     : { type : Function },
        onResourceTimeRangeClick            : { type : Function },
        onResourceTimeRangeContextMenu      : { type : Function },
        onResourceTimeRangeDblClick         : { type : Function },
        onResourceTimeRangeMouseDown        : { type : Function },
        onResourceTimeRangeMouseOut         : { type : Function },
        onResourceTimeRangeMouseOver        : { type : Function },
        onResourceTimeRangeMouseUp          : { type : Function },
        onResponsive                        : { type : Function },
        onRowCollapse                       : { type : Function },
        onRowExpand                         : { type : Function },
        onRowMouseEnter                     : { type : Function },
        onRowMouseLeave                     : { type : Function },
        onScroll                            : { type : Function },
        onSelectionChange                   : { type : Function },
        onSelectionModeChange               : { type : Function },
        onShow                              : { type : Function },
        onSplit                             : { type : Function },
        onSplitterCollapseClick             : { type : Function },
        onSplitterDragEnd                   : { type : Function },
        onSplitterDragStart                 : { type : Function },
        onSplitterExpandClick               : { type : Function },
        onStartCellEdit                     : { type : Function },
        onStartRowEdit                      : { type : Function },
        onSubGridCollapse                   : { type : Function },
        onSubGridExpand                     : { type : Function },
        onTickSizeChange                    : { type : Function },
        onTimeAxisChange                    : { type : Function },
        onTimeAxisHeaderClick               : { type : Function },
        onTimeAxisHeaderContextMenu         : { type : Function },
        onTimeAxisHeaderDblClick            : { type : Function },
        onTimeAxisHeaderMenuBeforeShow      : { type : Function },
        onTimeAxisHeaderMenuItem            : { type : Function },
        onTimeAxisHeaderMenuShow            : { type : Function },
        onTimelineContextChange             : { type : Function },
        onTimelineViewportResize            : { type : Function },
        onTimeRangeHeaderClick              : { type : Function },
        onTimeRangeHeaderContextMenu        : { type : Function },
        onTimeRangeHeaderDblClick           : { type : Function },
        onToggleGroup                       : { type : Function },
        onToggleNode                        : { type : Function },
        onToolClick                         : { type : Function },
        onUnlockRows                        : { type : Function },
        onUnsplit                           : { type : Function },
        onVisibleDateRangeChange            : { type : Function },

        // Features
        cellCopyPasteFeature          : { type : [Object, Boolean, String], default : undefined },
        cellEditFeature               : { type : [Object, Boolean, String], default : undefined },
        cellMenuFeature               : { type : [Object, Boolean, String], default : undefined },
        cellTooltipFeature            : { type : [Object, Boolean, String], default : undefined },
        columnAutoWidthFeature        : { type : [Object, Boolean, String], default : undefined },
        columnDragToolbarFeature      : { type : [Object, Boolean, String], default : undefined },
        columnLinesFeature            : { type : [Object, Boolean, String], default : undefined },
        columnPickerFeature           : { type : [Object, Boolean, String], default : undefined },
        columnRenameFeature           : { type : [Object, Boolean, String], default : undefined },
        columnReorderFeature          : { type : [Object, Boolean, String], default : undefined },
        columnResizeFeature           : { type : [Object, Boolean, String], default : undefined },
        excelExporterFeature          : { type : [Object, Boolean, String], default : undefined },
        fileDropFeature               : { type : [Object, Boolean, String], default : undefined },
        fillHandleFeature             : { type : [Object, Boolean, String], default : undefined },
        filterFeature                 : { type : [Object, Boolean, String], default : undefined },
        filterBarFeature              : { type : [Object, Boolean, String], default : undefined },
        groupFeature                  : { type : [Object, Boolean, String], default : undefined },
        groupSummaryFeature           : { type : [Object, Boolean, String], default : undefined },
        headerMenuFeature             : { type : [Object, Boolean, String], default : undefined },
        headerZoomFeature             : { type : [Object, Boolean, String], default : undefined },
        lockRowsFeature               : { type : [Object, Boolean, String], default : undefined },
        mergeCellsFeature             : { type : [Object, Boolean, String], default : undefined },
        nonWorkingTimeFeature         : { type : [Object, Boolean, String], default : undefined },
        panFeature                    : { type : [Object, Boolean, String], default : undefined },
        pdfExportFeature              : { type : [Object, Boolean, String], default : undefined },
        printFeature                  : { type : [Object, Boolean, String], default : undefined },
        quickFindFeature              : { type : [Object, Boolean, String], default : undefined },
        regionResizeFeature           : { type : [Object, Boolean, String], default : undefined },
        resourceMenuFeature           : { type : [Object, Boolean, String], default : undefined },
        resourceNonWorkingTimeFeature : { type : [Object, Boolean, String], default : undefined },
        resourceTimeRangesFeature     : { type : [Object, Boolean, String], default : undefined },
        rowCopyPasteFeature           : { type : [Object, Boolean, String], default : undefined },
        rowEditFeature                : { type : [Object, Boolean, String], default : undefined },
        rowExpanderFeature            : { type : [Object, Boolean, String], default : undefined },
        rowReorderFeature             : { type : [Object, Boolean, String], default : undefined },
        rowResizeFeature              : { type : [Object, Boolean, String], default : undefined },
        scheduleTooltipFeature        : { type : [Object, Boolean, String], default : undefined },
        searchFeature                 : { type : [Object, Boolean, String], default : undefined },
        sortFeature                   : { type : [Object, Boolean, String], default : undefined },
        splitFeature                  : { type : [Object, Boolean, String], default : undefined },
        stickyCellsFeature            : { type : [Object, Boolean, String], default : undefined },
        stripeFeature                 : { type : [Object, Boolean, String], default : undefined },
        summaryFeature                : { type : [Object, Boolean, String], default : undefined },
        timeAxisHeaderMenuFeature     : { type : [Object, Boolean, String], default : undefined },
        timeRangesFeature             : { type : [Object, Boolean, String], default : undefined },
        timeSpanHighlightFeature      : { type : [Object, Boolean, String], default : undefined },
        treeFeature                   : { type : [Object, Boolean, String], default : undefined },
        treeGroupFeature              : { type : [Object, Boolean, String], default : undefined },

    },

    data : () => {
        return {
            instanceClass : ResourceUtilization,
            instanceName : 'ResourceUtilization',

            isView : true,

            cellInstances : [],

            dataStores : {
                'originalStore': 'originals',
                'resourceTimeRangeStore': 'resourceTimeRanges',
                'timeRangeStore': 'timeRanges'
            },

            projectStores : false,

            featureNames : [
                'cellCopyPasteFeature',
                'cellEditFeature',
                'cellMenuFeature',
                'cellTooltipFeature',
                'columnAutoWidthFeature',
                'columnDragToolbarFeature',
                'columnLinesFeature',
                'columnPickerFeature',
                'columnRenameFeature',
                'columnReorderFeature',
                'columnResizeFeature',
                'excelExporterFeature',
                'fileDropFeature',
                'fillHandleFeature',
                'filterFeature',
                'filterBarFeature',
                'groupFeature',
                'groupSummaryFeature',
                'headerMenuFeature',
                'headerZoomFeature',
                'lockRowsFeature',
                'mergeCellsFeature',
                'nonWorkingTimeFeature',
                'panFeature',
                'pdfExportFeature',
                'printFeature',
                'quickFindFeature',
                'regionResizeFeature',
                'resourceMenuFeature',
                'resourceNonWorkingTimeFeature',
                'resourceTimeRangesFeature',
                'rowCopyPasteFeature',
                'rowEditFeature',
                'rowExpanderFeature',
                'rowReorderFeature',
                'rowResizeFeature',
                'scheduleTooltipFeature',
                'searchFeature',
                'sortFeature',
                'splitFeature',
                'stickyCellsFeature',
                'stripeFeature',
                'summaryFeature',
                'timeAxisHeaderMenuFeature',
                'timeRangesFeature',
                'timeSpanHighlightFeature',
                'treeFeature',
                'treeGroupFeature'
            ],

            configNames : [
                'adopt',
                'aggregateDataEntry',
                'aggregateHistogramDataForGroups',
                'animateFilterRemovals',
                'animateRemovingRows',
                'animateTreeNodeToggle',
                'ariaDescription',
                'ariaLabel',
                'assignmentFilterFn',
                'autoAdjustTimeAxis',
                'autoHeight',
                'barTextEffortUnit',
                'barTipEffortUnit',
                'barTooltipTemplate',
                'bbar',
                'bodyCls',
                'bubbleEvents',
                'bufferCoef',
                'bufferThreshold',
                'callOnFunctions',
                'collapsible',
                'config',
                'contentElementCls',
                'contextMenuTriggerEvent',
                'dataModelField',
                'defaultRegion',
                'defaultResourceImageName',
                'destroyStore',
                'destroyStores',
                'disableGridColumnIdWarning',
                'disableGridRowModelWarning',
                'dock',
                'drawer',
                'effortFormat',
                'effortUnit',
                'elementAttributes',
                'enableSticky',
                'enableTextSelection',
                'endParamName',
                'fillLastColumn',
                'fixedRowHeight',
                'footer',
                'formulaProviders',
                'fullRowRefresh',
                'getBarClass',
                'getBarDOMConfig',
                'getBarText',
                'getBarTextDOMConfig',
                'getDataEntryForAggregating',
                'getOutlineClass',
                'getOutlineDOMConfig',
                'getRecordData',
                'getRowHeight',
                'hardRefreshOnTimeAxisReconfigure',
                'header',
                'hideHorizontalScrollbar',
                'histogramWidgetClass',
                'hoverCls',
                'ignoreDomEventsWhileScrolling',
                'ignoreParentReadOnly',
                'includeInactiveEvents',
                'initAggregatedDataEntry',
                'listeners',
                'loadMask',
                'loadMaskDefaults',
                'loadMaskError',
                'localizable',
                'managedEventSizing',
                'maskDefaults',
                'masked',
                'maxDate',
                'maxTimeAxisUnit',
                'minDate',
                'monitorResize',
                'owner',
                'partner',
                'passStartEndParameters',
                'plugins',
                'preserveFocusOnDatasetChange',
                'preserveScrollOnDatasetChange',
                'preventTooltipOnTouch',
                'relayStoreEvents',
                'resizable',
                'resizeToFitIncludesHeader',
                'resourceImageExtension',
                'resourceImagePath',
                'resourceTimeRangeRenderer',
                'respectStoreFilters',
                'responsiveLevels',
                'ripple',
                'rootElement',
                'scaleColumn',
                'scalePoints',
                'scrollerClass',
                'scrollManager',
                'series',
                'showBarText',
                'showDirty',
                'showEffortUnit',
                'snapRelativeToEventStartDate',
                'startParamName',
                'stateful',
                'statefulEvents',
                'stateId',
                'stateProvider',
                'stickyHeaders',
                'strips',
                'subGridConfigs',
                'syncMask',
                'tab',
                'tabBarItems',
                'tbar',
                'timeAxis',
                'type',
                'ui',
                'visibleZoomFactor',
                'weekStartDay',
                'weight',
                'zoomKeepsOriginalTimespan',
                'zoomOnMouseWheel',
                'zoomOnTimeAxisDoubleClick'
            ],

            propertyConfigNames : [
                'alignSelf',
                'appendTo',
                'ariaLive',
                'barMargin',
                'cellEllipsis',
                'cls',
                'collapsed',
                'columnLines',
                'columns',
                'dataset',
                'disabled',
                'displayDateFormat',
                'emptyText',
                'enableEventAnimations',
                'enableUndoRedoKeys',
                'endDate',
                'extraData',
                'fillTicks',
                'flex',
                'forceFit',
                'height',
                'hidden',
                'hideFooters',
                'hideHeaders',
                'hideRowHover',
                'histogramWidget',
                'id',
                'infiniteScroll',
                'insertBefore',
                'insertFirst',
                'keyMap',
                'longPressTime',
                'margin',
                'maxHeight',
                'maxWidth',
                'maxZoomLevel',
                'minHeight',
                'minWidth',
                'minZoomLevel',
                'onBeforeAssignmentDelete',
                'onBeforeCancelCellEdit',
                'onBeforeCancelRowEdit',
                'onBeforeCellDelete',
                'onBeforeCellEditStart',
                'onBeforeColumnDragStart',
                'onBeforeColumnDropFinalize',
                'onBeforeColumnResize',
                'onBeforeCopy',
                'onBeforeCSVExport',
                'onBeforeDestroy',
                'onBeforeEventDelete',
                'onBeforeExcelExport',
                'onBeforeFillHandleDragStart',
                'onBeforeFinishCellEdit',
                'onBeforeFinishRowEdit',
                'onBeforeHide',
                'onBeforeHistogramDataCacheSet',
                'onBeforePan',
                'onBeforePaste',
                'onBeforePdfExport',
                'onBeforePresetChange',
                'onBeforeRenderHistogramRow',
                'onBeforeRenderRecordHistogram',
                'onBeforeRenderRow',
                'onBeforeRenderRows',
                'onBeforeRowCollapse',
                'onBeforeRowExpand',
                'onBeforeSelectionChange',
                'onBeforeSetRecord',
                'onBeforeShow',
                'onBeforeStartRowEdit',
                'onBeforeStateApply',
                'onBeforeStateSave',
                'onBeforeToggleGroup',
                'onBeforeToggleNode',
                'onCancelCellEdit',
                'onCatchAll',
                'onCellClick',
                'onCellContextMenu',
                'onCellDblClick',
                'onCellMenuBeforeShow',
                'onCellMenuItem',
                'onCellMenuShow',
                'onCellMenuToggleItem',
                'onCellMouseEnter',
                'onCellMouseLeave',
                'onCellMouseOut',
                'onCellMouseOver',
                'onCollapse',
                'onCollapseNode',
                'onColumnDrag',
                'onColumnDragStart',
                'onColumnDrop',
                'onColumnResize',
                'onColumnResizeStart',
                'onContextMenuItem',
                'onContextMenuToggleItem',
                'onCopy',
                'onCurrentTimelineUpdate',
                'onDataChange',
                'onDateRangeChange',
                'onDestroy',
                'onDirtyStateChange',
                'onDragSelecting',
                'onExpand',
                'onExpandNode',
                'onFileDrop',
                'onFillHandleBeforeDragFinalize',
                'onFillHandleDrag',
                'onFillHandleDragAbort',
                'onFillHandleDragEnd',
                'onFillHandleDragStart',
                'onFinishCellEdit',
                'onFinishRowEdit',
                'onFocusIn',
                'onFocusOut',
                'onGridRowBeforeDragStart',
                'onGridRowBeforeDropFinalize',
                'onGridRowDrag',
                'onGridRowDragAbort',
                'onGridRowDragStart',
                'onGridRowDrop',
                'onHeaderClick',
                'onHeaderMenuBeforeShow',
                'onHeaderMenuItem',
                'onHeaderMenuShow',
                'onHeaderMenuToggleItem',
                'onHide',
                'onHistogramDataCacheSet',
                'onLockRows',
                'onMouseOut',
                'onMouseOver',
                'onPaint',
                'onPaste',
                'onPdfExport',
                'onPresetChange',
                'onReadOnly',
                'onRecompose',
                'onRenderRow',
                'onRenderRows',
                'onResize',
                'onResourceMenuBeforeShow',
                'onResourceMenuItem',
                'onResourceMenuShow',
                'onResourceMenuToggleItem',
                'onResourceNonWorkingTimeClick',
                'onResourceNonWorkingTimeContextMenu',
                'onResourceNonWorkingTimeDblClick',
                'onResourceNonWorkingTimeMouseDown',
                'onResourceNonWorkingTimeMouseOut',
                'onResourceNonWorkingTimeMouseOver',
                'onResourceNonWorkingTimeMouseUp',
                'onResourceTimeRangeClick',
                'onResourceTimeRangeContextMenu',
                'onResourceTimeRangeDblClick',
                'onResourceTimeRangeMouseDown',
                'onResourceTimeRangeMouseOut',
                'onResourceTimeRangeMouseOver',
                'onResourceTimeRangeMouseUp',
                'onResponsive',
                'onRowCollapse',
                'onRowExpand',
                'onRowMouseEnter',
                'onRowMouseLeave',
                'onScroll',
                'onSelectionChange',
                'onSelectionModeChange',
                'onShow',
                'onSplit',
                'onSplitterCollapseClick',
                'onSplitterDragEnd',
                'onSplitterDragStart',
                'onSplitterExpandClick',
                'onStartCellEdit',
                'onStartRowEdit',
                'onSubGridCollapse',
                'onSubGridExpand',
                'onTickSizeChange',
                'onTimeAxisChange',
                'onTimeAxisHeaderClick',
                'onTimeAxisHeaderContextMenu',
                'onTimeAxisHeaderDblClick',
                'onTimeAxisHeaderMenuBeforeShow',
                'onTimeAxisHeaderMenuItem',
                'onTimeAxisHeaderMenuShow',
                'onTimelineContextChange',
                'onTimelineViewportResize',
                'onTimeRangeHeaderClick',
                'onTimeRangeHeaderContextMenu',
                'onTimeRangeHeaderDblClick',
                'onToggleGroup',
                'onToggleNode',
                'onToolClick',
                'onUnlockRows',
                'onUnsplit',
                'onVisibleDateRangeChange',
                'preserveScroll',
                'presets',
                'project',
                'readOnly',
                'recurrenceConfirmationPopup',
                'resourceMargin',
                'resourceTimeRanges',
                'resourceTimeRangeStore',
                'rowHeight',
                'rowLines',
                'rtl',
                'scrollable',
                'selectionMode',
                'showBarTip',
                'snap',
                'startDate',
                'stateSettings',
                'store',
                'suppressFit',
                'tickSize',
                'timeRanges',
                'timeRangeStore',
                'timeResolution',
                'title',
                'tools',
                'transitionDuration',
                'viewPreset',
                'visibleDate',
                'width',
                'workingTime'
            ],

            propertyNames : [
                'crudManager',
                'data',
                'eventColor',
                'eventStyle',
                'focusVisible',
                'hasChanges',
                'isEngineReady',
                'originalStore',
                'parent',
                'scrollLeft',
                'scrollTop',
                'scrollX',
                'selectedCell',
                'selectedCells',
                'selectedRecord',
                'selectedRecords',
                'selectedRows',
                'state',
                'timeZone',
                'tooltip',
                'zoomLevel'
            ],

            eventNames : [
                'beforeAssignmentDelete',
                'beforeCancelCellEdit',
                'beforeCancelRowEdit',
                'beforeCellDelete',
                'beforeCellEditStart',
                'beforeColumnDragStart',
                'beforeColumnDropFinalize',
                'beforeColumnResize',
                'beforeCopy',
                'beforeCSVExport',
                'beforeDestroy',
                'beforeEventDelete',
                'beforeExcelExport',
                'beforeFillHandleDragStart',
                'beforeFinishCellEdit',
                'beforeFinishRowEdit',
                'beforeHide',
                'beforeHistogramDataCacheSet',
                'beforePan',
                'beforePaste',
                'beforePdfExport',
                'beforePresetChange',
                'beforeRenderHistogramRow',
                'beforeRenderRecordHistogram',
                'beforeRenderRow',
                'beforeRenderRows',
                'beforeRowCollapse',
                'beforeRowExpand',
                'beforeSelectionChange',
                'beforeSetRecord',
                'beforeShow',
                'beforeStartRowEdit',
                'beforeStateApply',
                'beforeStateSave',
                'beforeToggleGroup',
                'beforeToggleNode',
                'cancelCellEdit',
                'catchAll',
                'cellClick',
                'cellContextMenu',
                'cellDblClick',
                'cellMenuBeforeShow',
                'cellMenuItem',
                'cellMenuShow',
                'cellMenuToggleItem',
                'cellMouseEnter',
                'cellMouseLeave',
                'cellMouseOut',
                'cellMouseOver',
                'collapse',
                'collapseNode',
                'columnDrag',
                'columnDragStart',
                'columnDrop',
                'columnResize',
                'columnResizeStart',
                'contextMenuItem',
                'contextMenuToggleItem',
                'copy',
                'currentTimelineUpdate',
                'dataChange',
                'dateRangeChange',
                'destroy',
                'dirtyStateChange',
                'dragSelecting',
                'expand',
                'expandNode',
                'fileDrop',
                'fillHandleBeforeDragFinalize',
                'fillHandleDrag',
                'fillHandleDragAbort',
                'fillHandleDragEnd',
                'fillHandleDragStart',
                'finishCellEdit',
                'finishRowEdit',
                'focusIn',
                'focusOut',
                'gridRowBeforeDragStart',
                'gridRowBeforeDropFinalize',
                'gridRowDrag',
                'gridRowDragAbort',
                'gridRowDragStart',
                'gridRowDrop',
                'headerClick',
                'headerMenuBeforeShow',
                'headerMenuItem',
                'headerMenuShow',
                'headerMenuToggleItem',
                'hide',
                'histogramDataCacheSet',
                'lockRows',
                'mouseOut',
                'mouseOver',
                'paint',
                'paste',
                'pdfExport',
                'presetChange',
                'readOnly',
                'recompose',
                'renderRow',
                'renderRows',
                'resize',
                'resourceMenuBeforeShow',
                'resourceMenuItem',
                'resourceMenuShow',
                'resourceMenuToggleItem',
                'resourceNonWorkingTimeClick',
                'resourceNonWorkingTimeContextMenu',
                'resourceNonWorkingTimeDblClick',
                'resourceNonWorkingTimeMouseDown',
                'resourceNonWorkingTimeMouseOut',
                'resourceNonWorkingTimeMouseOver',
                'resourceNonWorkingTimeMouseUp',
                'resourceTimeRangeClick',
                'resourceTimeRangeContextMenu',
                'resourceTimeRangeDblClick',
                'resourceTimeRangeMouseDown',
                'resourceTimeRangeMouseOut',
                'resourceTimeRangeMouseOver',
                'resourceTimeRangeMouseUp',
                'responsive',
                'rowCollapse',
                'rowExpand',
                'rowMouseEnter',
                'rowMouseLeave',
                'scroll',
                'selectionChange',
                'selectionModeChange',
                'show',
                'split',
                'splitterCollapseClick',
                'splitterDragEnd',
                'splitterDragStart',
                'splitterExpandClick',
                'startCellEdit',
                'startRowEdit',
                'subGridCollapse',
                'subGridExpand',
                'tickSizeChange',
                'timeAxisChange',
                'timeAxisHeaderClick',
                'timeAxisHeaderContextMenu',
                'timeAxisHeaderDblClick',
                'timeAxisHeaderMenuBeforeShow',
                'timeAxisHeaderMenuItem',
                'timeAxisHeaderMenuShow',
                'timelineContextChange',
                'timelineViewportResize',
                'timeRangeHeaderClick',
                'timeRangeHeaderContextMenu',
                'timeRangeHeaderDblClick',
                'toggleGroup',
                'toggleNode',
                'toolClick',
                'unlockRows',
                'unsplit',
                'visibleDateRangeChange'
            ]
        };
    },

    /**
     * Called after the instance has been mounted
     */
    mounted() {
        const
            me = this,
            {
                createWidget,
                relayStores,
                watchProps,
                processCellContent,
                processEventContent,
                hasFrameworkRenderer
            }  = WrapperHelper();

        me.instance = createWidget({
            me,
            props                : me.$props,
            data                 : me.$data,
            listeners            : me.$listeners,
            emit                 : me.$emit.bind(me),
            element              : me.$el,
            processCellContent   : processCellContent.bind(me),
            processEventContent  : processEventContent.bind(me),
            hasFrameworkRenderer : hasFrameworkRenderer.bind(me)
        });
        // Backwards compatibility for gridInstance, schedulerInstance etc.
        me[StringHelper.uncapitalize(me.instanceClass.$name) + 'Instance'] = me.instance;
        relayStores(me.$data, me.instance);

        const watcher = me.$watch.bind(me);
        watchProps(me, me.instance, me.$props, me.$data, watcher);
    },

    /**
     * Called right before a Vue instance is destroyed. At this stage the instance is still fully functional.
     */
    beforeDestroy() {
        if (this.instance) {
            this.instance.destroy();
        }
    }

};

</script>
